import wixLocation from 'wix-location';
import wixData from 'wix-data';

import wixAnimations from 'wix-animations';
let querycontact = wixData.query("eebamjeu");
let queryservise = wixData.query("9dbhb2ddj5dbfbk0g");


let siteurl = "http://www.checkup.co.il"
 let color1 = "#306CB3"
let color2 = "#2277C7"
let slideOptions = {
  "duration":   500,
  "delay":     200,
   "direction":   "right",

};
let fadeOptions = {
  "duration":   200,
  "delay":     0,
 

};
$w.onReady(function () {
     let timelinelogo = wixAnimations.timeline();
let logo = $w("#logo")
 
  timelinelogo
                .add(logo, {
                    "scale": 0.7,
                    "opacity": 0.8,
                    "duration": 200
                })
     




querycontact

        .find()

        .then((results) => {
            if (results.items.length > 0) {
                $w("#Contact").data = results.items

            }

        });
    queryservise
.eq("show",true)
.ascending("pos")
        .find()

        .then((results) => {
            if (results.items.length > 0) {
        $w("#servise").data = results.items

            }
   
        });

















    

    
    $w("#servise").onItemReady(($item, itemData, index) => {
        let timelineitem = wixAnimations.timeline();

        let title = $item("#servisetitle")
        let icon = $item("#serviseicon")
        let item = $item("#serviseitem")
  let button2 = $item("#button21")

	
if(itemData.showbooking){
    button2.expand()
       button2.link   = itemData.booking

}
  	let short = $item("#text170")
		let button =$item("#button18")
        title.text = itemData.title
        icon.src = itemData.icon
        short.text = itemData.par
        button.link   = itemData.link
         

    });
    $w("#Contact").onItemReady(($item, itemData, index) => {
       
        let label = $item("#labelContact")
        let item = $item("#itemContact")
        label.text = itemData.title
        let i = 0
         $w("#radioGroup1").selectedIndex = i
 $w("#vectorImage24").onClick((event) => {
     
     i = i +1
     if (i ===itemData.gallery.length  ) {
        i =0 
      
     }
       $w("#imageContact").src = itemData.gallery[i].src
       $w("#radioGroup1").selectedIndex = i
     });
        item.onClick((event) => {
             let opts0 = []
        for (let c = 0; c < itemData.gallery.length; c++) {

            opts0.push({ "label": (c + 1).toString(), "value":  itemData.gallery[c].src });

        }

        $w("#radioGroup1").options = opts0;
        $w("#radioGroup1").expand()
         $w("#vectorImage24").expand()
            i =0 
            $w("#servise").data = []
            queryservise
                .hasSome("eebamjeu", [itemData._id])
                .eq("show",true)
.ascending("pos")
                .find()
                .then((results) => {
                    if (results.items.length > 0) {
                        $w("#servise").data = results.items

                    }

                });

            $w("#text185").html = itemData.time
           
            $w("#imageContact").expand()

            $w("#text120").text = "השאר/י פנייה לסניף " + itemData.title
            $w("#text122").text = "מה תמצאו בסניף " + itemData.title + " ?"
            $w("#imageContact").src = itemData.gallery[0].src

        });
     
    });
  $w("#logo").onClick((event) => {
if ($w("#menu").collapsed) {
   wixLocation.to(siteurl)
}else{
     $w("#menu").collapse()
      timelinelogo.reverse()

}
      
        
      });
       $w("#open").onClick((event) => {
           
            timelinelogo.play()

      $w("#menu").expand()
      });
      
$w("#radioGroup1").onChange((event) => {

            $w("#imageContact").src = event.target.value;
         

        });
});



